import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import Carousel from "react-bootstrap/Carousel";
import { useNewHomeAPI } from '../../hooks/useAllCategoryData';

const Couture = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const videoRef = useRef(null); // Reference to the video element

  const handleVideoSelect = () => {
    setSelectedVideo();
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    if (videoRef.current) {
      videoRef.current.pause(); // Stop the video when modal closes
      videoRef.current.currentTime = 0; // Reset to the beginning
    }
  };
  const { isLoading, error, data } = useNewHomeAPI();
  if (error) return <div>{error.message}</div>;
  return (
    <>
    <div className='couture-full'>
      {/* <div className='flare-box'><img src='images/about/flare-red.png' alt='' /></div> */}
        <h2>Couture'<span>26</span> {/* <img src='images/couture25.png' alt='' className='couture-25' /> */}{/* <span className="newfont-heading">Couture'25</span> */} <small><Link to="/category/lehengas?orderBy=default&category_product=lehengas_the-timeless-collection_the-regal-collection_the-sleek-edit_printed-lehengas_the-signature-edit">Lehengas</Link> / <Link to="/category/gowns?orderBy=default&category_product=gowns_the-timeless-collection_signature-edit">Gowns</Link> / <Link to="/category/sarees?category_product=sarees&orderBy=default">Sarees</Link> & <Link to="/category/stitched-sarees?category_product=stitched-sarees&orderBy=default">Drape Sarees</Link></small></h2>
        <div className='sneak-peek'><span onClick={() => handleVideoSelect()}>Take a sneak peek</span></div>
       <div className='couture-img'>
        {data?.coutureBanner && (
       <Carousel variant="dark" fade={true} interval={4000} pause={false} touch={true}>          
       {data.coutureBanner.map((e,i)=> (
          <Carousel.Item key={i}><img src={`${process.env.REACT_APP_IMAGE_URL}/home/couture/${e.url}`} alt="" /></Carousel.Item>              
        ))}
       </Carousel>
       )}
       {/* <img src='/images/category-img/drape-sarees.jpg' alt=''/> <Link to="#">EXPLORE</Link> */}</div>
    </div>
    {isModalOpen && (
        <div className="video-modal">
            <div className="video-overlay"><span className="close" onClick={closeModal}></span></div>
          <div className="video-modal-content">
            <span className="close mobile-video-close" onClick={closeModal}></span>            
                <video ref={videoRef} width="528" height="937" controls autoPlay  playsInline webkitPlaysInline preload="auto">
                  <source src={`${process.env.REACT_APP_IMAGE_URL}home/couture/final.mp4`} type="video/mp4" />
                </video>           
          </div>
        </div>
      )}
  </>
  )
}

export default Couture
